import LayoutSetParticipant from 'components/ui/layout-set/participant/layout-set-participant';

import PageParticipantSchedules from 'components/pages/participant/schedules/page-participant-schedules';
import PageParticipantMyPreferences from 'components/pages/participant/my-preferences/page-participant-my-preferences';

import PageJoinInstance from 'components/pages/participant/public/join-instance/page-join-instance';

import PageParticipantLogin from 'components/pages/participant/public/login/page-participant-login';
import PageParticipantLogout from 'components/pages/participant/public/logout/page-participant-logout';

import PageParticipantForgotPassword from 'components/pages/participant/public/forgot-password/page-participant-forgot-password';
import PageParticipantResetPassword from 'components/pages/participant/public/reset-password/page-participant-reset-password';
import PageParticipantActivateAccount from 'components/pages/participant/public/activate-account/page-participant-activate-account';

import PageParticipantProfilePicture from 'components/pages/participant/my-preferences/page-participant-profile-picture';

import PageParticipantChangeEmail from 'components/pages/participant/my-preferences/page-participant-change-email';
import PageParticipantVerifyEmail from 'components/pages/participant/public/verify-email/page-participant-verify-email';

import PageParticipantChangePassword from 'components/pages/participant/my-preferences/page-participant-change-password';
import PageParticipantDeactivateAccount from 'components/pages/participant/my-preferences/deactivate-account/page-participant-deactivate-account';

import PageParticipantPublicSchedules from 'components/pages/participant/public/schedules/page-participant-public-schedules';

import { SCOPES } from 'constants/roles';

const auth = {
  roles: SCOPES.PARTICIPANT,
  redirect: { name: 'participant-area-login' },
  forbiddenRedirect: { name: 'participant-area-forbidden' },
};

export default [
  {
    path: '/participant',
    component: LayoutSetParticipant,
    props: route => ({
      token: route.query.token,
    }),
    children: [
      {
        path: 'schedules',
        name: 'participant-area-schedules',
        component: PageParticipantSchedules,
        props: route => ({
          schedule_id: route.query.schedule_id,
          schedule_date: route.query.schedule_date,
          meta: {
            title: 'label.my_schedules',
            section: 'label.participant',
          },
        }),
        meta: {
          auth,
        },
      },
      {
        path: 'my-preferences',
        name: 'participant-area-my-preferences',
        component: PageParticipantMyPreferences,
        props: {
          meta: {
            title: 'label.my_preferences',
            section: 'label.participant',
          },
        },
        meta: {
          auth,
          section: 'my-preferences',
        },
      },
      {
        path: 'profile-picture',
        name: 'participant-area-profile-picture',
        component: PageParticipantProfilePicture,
        props: {
          meta: {
            title: 'label.profile_picture',
            section: 'label.participant',
          },
        },
        meta: {
          auth,
          section: 'my-preferences',
        },
      },
      {
        path: 'change-email',
        name: 'participant-area-change-email',
        component: PageParticipantChangeEmail,
        props: {
          meta: {
            title: 'label.change_email',
            section: 'label.participant',
          },
        },
        meta: {
          auth,
          section: 'my-preferences',
        },
      },
      {
        path: 'change-password',
        name: 'participant-area-change-password',
        component: PageParticipantChangePassword,
        props: {
          meta: {
            title: 'label.change_password',
            section: 'label.participant',
          },
        },
        meta: {
          auth,
          section: 'my-preferences',
        },
      },
      {
        path: 'deactivate-account',
        name: 'participant-area-deactivate-account',
        component: PageParticipantDeactivateAccount,
        props: {
          meta: {
            title: 'label.deactivate_account',
            section: 'label.participant',
          },
        },
        meta: {
          auth,
          section: 'my-preferences',
        },
      },
      {
        path: 'join-instance',
        name: 'participant-area-join-instance',
        component: PageJoinInstance,
        props: route => ({
          token: route.query.token,
          meta: {
            title: 'label.join_instance',
            section: 'label.participant',
            navigation: {
              success: 'home-participant',
            },
          },
        }),
        meta: {
          auth: false,
          notFoundRedirect: '/403',
        },
      },
      {
        path: 'login',
        name: 'participant-area-login',
        component: PageParticipantLogin,
        props: route => ({
          redirect: route.query.redirect,
          meta: {
            title: 'label.login',
            section: 'label.participant',
          },
        }),
        meta: { auth: false },
      },
      {
        path: 'public-schedules',
        name: 'participant-area-public-schedules',
        component: PageParticipantPublicSchedules,
        props: route => ({
          token: route.query.token,
          schedule_id: route.query.schedule_id,
          schedule_date: route.query.schedule_date,
          meta: {
            title: 'label.my_schedules',
            section: 'label.participant',
          },
        }),
        meta: { auth: false },
      },
      {
        path: 'forgot-password',
        name: 'participant-area-forgot-password',
        component: PageParticipantForgotPassword,
        props: route => ({
          redirect: route.query.redirect,
          meta: {
            title: 'label.forgot_password',
            section: 'label.participant',
          },
        }),
        meta: { auth: false },
      },
      {
        path: 'reset-password',
        name: 'participant-area-reset-password',
        component: PageParticipantResetPassword,
        props: route => ({
          token: route.query.token,
          meta: {
            title: 'label.reset_password',
            section: 'label.participant',
          },
        }),
        meta: { auth: false },
      },
      {
        path: 'activate-account',
        name: 'participant-area-activate-account',
        component: PageParticipantActivateAccount,
        props: route => ({
          token: route.query.token,
          meta: {
            title: 'label.activate_account',
            section: 'label.participant',
          },
        }),
        meta: { auth: false },
      },
      {
        path: 'verify-email',
        name: 'participant-area-verify-email',
        component: PageParticipantVerifyEmail,
        props: route => ({
          token: route.query.token,
          meta: {
            title: 'label.verify_email',
            section: 'label.participant',
          },
        }),
      },
      {
        path: 'logout',
        name: 'participant-area-logout',
        component: PageParticipantLogout,
        meta: { auth: true },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/participant/index.js